import { render, staticRenderFns } from "./prod_type39.vue?vue&type=template&id=a0c08070&scoped=true"
import script from "./prod_type39.vue?vue&type=script&lang=js"
export * from "./prod_type39.vue?vue&type=script&lang=js"
import style0 from "./prod_type39.vue?vue&type=style&index=0&id=a0c08070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c08070",
  null
  
)

export default component.exports